<template>
    <div>
        <b-button v-if="showCreate" variant="primary" @click="goToCreate">
            <i class="fas fa-fw fa-plus"></i> Ajouter une tâche
        </b-button>
        <b-button v-if="showReturn" variant="secondary" @click="goToIndex">
            <i class="fas fa-fw fa-arrow-alt-left"></i> Retour à la liste des
            tâches
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'TasksFooter',

    methods: {
        goToCreate() {
            this.$store.commit('browsing/SET_EDITING')
            this.$store.commit('browsing/SET_PAGE_NAME', 'tasks.create')
        },
        goToIndex() {
            this.$store.commit('browsing/RESET_EDITING')
            this.$store.commit('browsing/SET_PAGE_NAME', 'tasks.index')
        },
    },

    computed: {
        ...mapState({
            activePage: (state) => state.browsing.pageName,
            editing: (state) => state.browsing.editing,
        }),

        showCreate() {
            return this.activePage === 'tasks.index' && !this.editing
        },

        showReturn() {
            return (
                this.activePage === 'tasks.create' ||
                this.activePage === 'tasks.index' ||
                this.editing
            )
        },
    },
}
</script>

<style scoped></style>
